export default function animateSocialSection() {
  $('.social-container').attr({
    'data-aos': 'fade-in',
    'data-aos-delay': 200,
    'data-aos-easing': 'ease-in-out',
    'data-aos-duration': '400',
    'data-aos-once': 'true',
    'data-aos-offset': '200',
  });
}
